<template>
  <div class="col s12">
    <div class="row breadcrumb-margins">
      <div class="col">
        <RailObjectBreadCrumb :railObjectId.sync="railObjectIdbc" @set-parent="setParent"/>
      </div>

      <div v-if="children && children.length > 0" class="breadcrumb-div" @mouseenter="railObjectChildrenVisible = true" @mouseleave="railObjectChildrenVisible = false">
        <span class="breadcrumb-link-main" @click="railObjectChildrenVisible = true">{{childObjectName!=null ? childObjectName : '...'}}</span>
        <transition name="slide-fade">
          <div v-if="railObjectChildrenVisible" class="dialog no-padding inner-content">
            <div class="inner-breadcrumb-content z-depth-3">
              <table class="breadcrumb-table striped highlight">
                <thead>
                  <th>
                    <span>{{ $t('views.breadcrumb.railobject') }}</span>
                    <span class="right" @click="railObjectChildrenVisible = false"><i class="material-icons clickable">cancel</i></span>
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in children" :key="index">
                    <td @click="setChild(item)"><span class="clickable">{{ item.Name }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="railObjectIdbc">
      <div class="row" v-show="childObjectName !== null">
        <div class="col s12 axlecounterpage">
          <div class="row no-margin-bottom">
            <div class="col s12">
              <ul class="tabs">
                <li class="tab col"><a v-bind:class="{'active': activeTab === 'zprstatus'}" class="clickable" @click="activeTab = 'zprstatus'">ZPR Status</a></li>
                <li class="tab col"><a v-bind:class="{'active': activeTab === 'measurement'}" class="clickable" @click="activeTab = 'measurement'">Measurement</a></li>
                <li class="tab col"><a v-bind:class="{'active': activeTab === 'alarmsetting'}" class="clickable" @click="activeTab = 'alarmsetting'">Alarm setting</a></li>
                <li class="tab col"><a v-bind:class="{'active': activeTab === 'logbook'}" class="clickable" @click="activeTab = 'logbook'">Logbook</a></li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <zprstatus v-if="activeTab === 'zprstatus'"></zprstatus>
              <measurement v-if="activeTab === 'measurement'"></measurement>
              <alarmsetting v-if="activeTab === 'alarmsetting'"></alarmsetting>
              <logbook v-if="activeTab === 'logbook'"></logbook>
            </div>
          </div>
        </div>
      </div>
      <div v-show="childObjectName === null">
        <p>Please select an axlecounter</p>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchApi from '../../services/api/switch/SwitchApi'
import RailObjectBreadCrumb from '../../components/RailObjectBreadCrumb'
import Alarmsetting from './_alarmSetting.vue'
import Logbook from './_logbook.vue'
import Measurement from './_measurement.vue'
import ZprStatus from './_zprState.vue'
import M from 'materialize-css'
import Router from '../../router/index'

export default {
  data () {
    return {
      activeTab: 'zprstatus',
      railObjectIdbc: undefined,
      parentRailObject: undefined,
      children: [],
      railObjectChildrenVisible: false,
      childObjectName: null
    }
  },
  components: {
    alarmsetting: Alarmsetting,
    logbook: Logbook,
    measurement: Measurement,
    zprstatus: ZprStatus,
    RailObjectBreadCrumb
  },
  mounted: function () {
    M.Tabs.init(document.querySelectorAll('tabs'))
    this.loadData()
  },
  methods: {
    loadData () {
      this.railObjectIdbc = parseInt(this.$route.params.railobjectid)
      this.getSwitch(this.$route.params.railobjectid)
    },
    setChild (childObject) {
      this.railObjectChildrenVisible = false
      if (childObject) {
        this.childObjectName = childObject.Name
        Router.push({
          name: 'AxleCounter',
          params: {
            railobjectid: childObject.RailObjectId
          },
          props: true
        })
        this.loadData()
      }
    },
    getSwitch (railObjectId) {
      if (railObjectId) {
        SwitchApi.getSwitch(railObjectId, null).then(result => {
          // Result is parent, update breadcrumb, draw children
          if (result.data && result.data.SwitchAxleCounters && result.data.ParentRailObjectId === null) {
            this.children = []
            result.data.SwitchAxleCounters.forEach(ac => {
              this.children.push(ac)
              this.parentRailObject = result.data
            })
          }

          // Result is child, update breadcrumb, draw children
          if (result.data && result.data.ParentRailObjectId !== null) {
            this.railObjectIdbc = result.data.ParentRailObjectId
            this.children = []
            this.childObjectName = result.data.Name
            this.getSwitch(result.data.ParentRailObjectId)
          }
        })
      }
    },
    setParent (event) {
      this.railObjectIdbc = event
      this.childObjectName = null
      this.getSwitch(this.railObjectIdbc)
    }
  }
}

</script>

<style scoped>
  .axlecounterpage {
    background-color: white;
    height: 97vh;
  }

  .tabs .active {
    border-bottom: 2px solid #56ccf2;
  }

  .breadcrumb-div {
    display: inline-block;
  }

  .breadcrumb-link {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0,0,0, .56);
    /* cursor: pointer; */
  }
  .breadcrumb-link-main {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87);
    /* cursor: pointer; */
  }
  .inner-breadcrumb-content {
    max-height: 300px;
    width: 345px;
    overflow-y: auto;
    background-color: white;
    /* border: 1px solid  rgba(0, 0, 0, 0.56); */
    font-family: Roboto;
  }
  .breadcrumb-table {
    position: relative;
  }
  .breadcrumb-table thead tr {
    border-top: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .breadcrumb-table th, .breadcrumb-table td {
    padding: 5px 5px;
  }
  .breadcrumb-margins {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .inner-content {
    position: fixed;
    z-index: 4;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axlecounter/AxleCounter.vue